module.exports = __webpack_public_path__ + "static/media/eduMain.68696e8e.png";